import gql from 'graphql-tag';

// --------- Queries ---------

export const CUSTOMER_QUERY = gql`
  query CustomerQuery {
    customer {
      recordId
      customerId
      name
      website
      type
      customerSince
      accountStatus
      doNotService
      serviceHold
      phoneNumber
      requiresPO
      isCODCustomer
      customerParentId
    }
  }
`;

export const CUSTOMER_FAMILY_QUERY = gql`
  query CustomerFamilyQuery {
    customerFamily {
      recordId
      customerId
      name
      customerParentId
      serviceArea
      address {
        city
        state
      }
    }
  }
`;

export const PROJECTS_FOR_LOCATION_QUERY = gql`
  query ProjectsForLocationQuery($customerId: String!) {
    projectsForLocation(customerId: $customerId) {
      name
      recordId
      projectId
      archived
      address {
        street
        city
        state
        zipCode
      }
      location {
        latitude
        longitude
      }
      customer {
        customerId
        name
        serviceArea
        address {
          city
          state
        }
      }
    }
  }
`;

export const PROJECTS_QUERY = gql`
  query CustomerProjectsQuery {
    projects {
      name
      recordId
      projectId
      archived
      address {
        street
        city
        state
        zipCode
      }
      location {
        latitude
        longitude
      }
      customer {
        customerId
        name
        serviceArea
        address {
          city
          state
        }
      }
      # currentDispatchSets {
      #   recordId
      # }
    }
  }
`;

export const PROJECT_DETAILS_QUERY = gql`
  query ProjectDetailsQuery($projectId: String!) {
    project(projectId: $projectId) {
      name
      recordId
      projectId
      address {
        street
        city
        state
        zipCode
      }
      location {
        latitude
        longitude
      }
      customer {
        customerId
        name
        serviceArea
        address {
          city
          state
        }
      }
      currentDispatchSets {
        recordId
        intendedUse
        workOrderId
        poAssigned
        subProject {
          recordId
          subProjectId
          name
        }
        box {
          recordId
          boxSize
          boxNumber
          boxId
        }
      }
    }
  }
`;

export const DISPATCH_SET_DETAILS_QUERY = gql`
  query DispatchSetDetailsQuery($workOrderId: String!) {
    dispatchSet(workOrderId: $workOrderId) {
      recordId
      workOrderId
      intendedUse
      dateCreated
      dateSet
      specialInstructions
      tripType
      poAssigned
      status
      boxSize
      box {
        boxId
        boxSize
        boxNumber
      }
      project {
        name
        address {
          street
        }
      }
      subProjectId
      subProject {
        name
      }
      dispatchPull {
        recordId
        tripType
        dateNeededBy
        specialInstructions
        orderedByName
      }
      orderedByName
      stagedOrder {
        userName
      }
    }
  }
`;

export const STAGED_ORDER_WORK_ORDER = gql`
  query StagedOrderForWorkOrderId($workOrderId: String!) {
    stagedOrder(workOrderId: $workOrderId) {
      recordId
    }
  }
`;

export const DISPATCH_SET_ORDERS_QUERY = gql`
  query DispatchSetOrdersQuery($status: String!, $range: Int, $offset: Int) {
    dispatchSets(status: $status, range: $range, offset: $offset) {
      recordId
      workOrderId
      intendedUse
      dateCreated
      dateSet
      dateNeededBy
      specialInstructions
      tripType
      poAssigned
      status
      boxSize
      box {
        boxId
        boxSize
        boxNumber
      }
      project {
        projectId
        name
        address {
          street
        }
      }
      subProject {
        name
      }
      dispatchPull {
        recordId
        tripType
        intendedUse
        specialInstructions
        respotReason
        dateNeededBy
        orderedByName
      }
      orderedByName
      stagedOrder {
        userName
      }
    }
  }
`;

export const DISPATCH_SET_ORDERS_FOR_LOCATION_QUERY = gql`
  query DispatchSetOrdersForLocationQuery(
    $status: String!
    $range: Int
    $customerId: String!
  ) {
    dispatchSetsForLocation(
      customerId: $customerId
      status: $status
      range: $range
    ) {
      recordId
      workOrderId
      intendedUse
      dateCreated
      dateSet
      dateNeededBy
      specialInstructions
      tripType
      poAssigned
      status
      boxSize
      box {
        boxId
        boxSize
        boxNumber
      }
      project {
        projectId
        name
        address {
          street
        }
      }
      subProject {
        name
      }
      dispatchPull {
        recordId
        tripType
        intendedUse
        specialInstructions
        respotReason
        dateNeededBy
        orderedByName
      }
      orderedByName
      stagedOrder {
        userName
      }
    }
  }
`;

export const DISPATCH_SETS_CURRENT = gql`
  query DispatchSetOrdersQuery($status: String!, $range: Int) {
    dispatchSets(status: $status, range: $range) {
      recordId
      workOrderId
      intendedUse
      dateSet
      specialInstructions
      tripType
      poAssigned

      projectId
      project {
        projectId
        name
      }

      boxSize
      box {
        boxId
        boxSize
        boxNumber
      }
      subProject {
        name
      }
    }
  }
`;

export const DISPATCH_SET_ORDER_DETAILS_QUERY = gql`
  query DispatchSetOrdersQuery($workOrderId: String!) {
    dispatchSet(workOrderId: $workOrderId) {
      recordId
      workOrderId
      intendedUse
      dateCreated
      dateSet
      specialInstructions
      tripType
      poAssigned
      status

      boxSize
      box {
        boxId
        boxSize
        boxNumber
      }
      project {
        projectId
        name
        address {
          street
        }
      }
      subProject {
        name
      }
      dispatchPull {
        recordId
        tripType
        intendedUse
        specialInstructions
        respotReason
        dateNeededBy
        orderedByName
      }
      orderedByName
      stagedOrder {
        recordId
        tripType
        userName
      }
      driverPullId
    }
  }
`;

export const AVAILABLE_POS = gql`
  query AvailablePOs($subProjectId: String!) {
    purchaseOrdersAvailable(subProjectId: $subProjectId) {
      purchaseOrderNumber
      workOrderId
      isRespotPO
    }
  }
`;

export const PROJECT_SUBPROJECTS_QUERY = gql`
  query SubProjects($projectId: String!) {
    subProjects(projectId: $projectId) {
      subProjectId
      name
    }
  }
`;

export const DISPATCH_SET_BY_BOX = gql`
  query DispatchSetByBoxNumber($boxNumber: String!) {
    dispatchSetByBoxNumber(boxNumber: $boxNumber) {
      recordId
      workOrderId
      projectId
    }
  }
`;

export const INVOICES = gql`
  query Invoices($customerId: ID) {
    invoices(customerId: $customerId) {
      id
      amount
      balance
      invoiceDate
      invoiceArchiveURL
      projectName
      subProjectName
      description
    }
  }
`;

export const BOX_USES = gql`
  query BoxUses {
    boxUses
  }
`;

export const BOX_OPTIONS = gql`
  query BoxOptions {
    boxOptions {
      useSizeMapping {
        use {
          display
          value
        }
        sizes {
          display
          value
        }
      }
    }
  }
`;

export const LAST_SET_SETTINGS = gql`
  query LastSetSettings {
    lastSetSettings {
      intendedUse
      boxSize
    }
  }
`;

// --------- Mutations ---------

export const CREATE_DISPATCH_SET = gql`
  mutation CreateDispatchSet(
    $projectId: String!
    $date: String!
    $time: String
    $instructions: String!
    $subProject: String
    $use: String!
    $size: String!
    $ponumber: String!
  ) {
    createDispatchSet(
      projectId: $projectId
      date: $date
      time: $time
      instructions: $instructions
      subProject: $subProject
      use: $use
      size: $size
      ponumber: $ponumber
    ) {
      code
      title
      message
    }
  }
`;

export const CREATE_DISPATCH_PULL = gql`
  mutation CreateDispatchPull(
    $workOrderId: String!
    $date: String!
    $time: String
    $instructions: String!
    $ponumber: String!
    $boxNumber: String
  ) {
    createDispatchPull(
      workOrderId: $workOrderId
      date: $date
      time: $time
      instructions: $instructions
      ponumber: $ponumber
      boxNumber: $boxNumber
    ) {
      code
      title
      message
    }
  }
`;

export const CREATE_DISPATCH_ROUNDTRIP = gql`
  mutation createDispatchRoundtrip(
    $workOrderId: String!
    $date: String!
    $time: String
    $instructions: String!
    $use: String!
    $ponumber: String!
    $boxNumber: String
  ) {
    createDispatchRoundtrip(
      workOrderId: $workOrderId
      date: $date
      time: $time
      instructions: $instructions
      use: $use
      ponumber: $ponumber
      boxNumber: $boxNumber
    ) {
      code
      title
      message
    }
  }
`;

export const CREATE_DISPATCH_RESPOT = gql`
  mutation createDispatchRespot(
    $workOrderId: String!
    $date: String!
    $time: String
    $instructions: String!
    $reason: String!
    $ponumber: String!
    $boxNumber: String
  ) {
    createDispatchRespot(
      workOrderId: $workOrderId
      date: $date
      time: $time
      instructions: $instructions
      reason: $reason
      ponumber: $ponumber
      boxNumber: $boxNumber
    ) {
      code
      title
      message
    }
  }
`;
